// Guard de ruta por ÁREA. Teclear /pedidos-ventas siendo de logística no debe
// enseñar una pantalla que se va a llenar de 403.
//
// Mismo patrón que `RequireProduccion`: comparte la query ['auth-me'] y ESPERA a
// que resuelva, porque redirigir durante la carga expulsaría a un usuario
// legítimo que acaba de recargar.
//
// Esto es cortesía, no seguridad: el cierre real es `exigir_modulo` en el
// backend. Un guard de ruta vive en el navegador y el navegador es del usuario.
import { Navigate, Outlet } from 'react-router-dom'
import { useModulos, type Modulo } from '@/hooks/useModulos'

export function RequireModulo({ modulo }: { modulo: Modulo }) {
  const { puede, cargando } = useModulos()
  if (cargando) return null
  if (!puede(modulo)) return <Navigate to="/home" replace />
  return <Outlet />
}
